export const outlookConfig = {
  clientId: OUTLOOK_CREDENTIALS_CLIENT_ID,
  redirectUri: OUTLOOK_CREDENTIALS_REDIRECT_URL,
};

export const buildOutlookAuthorizeUrl = (workspaceSlug?: string) => {
  const slug = workspaceSlug ? `redirect-${workspaceSlug}` : "";

  return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${OUTLOOK_CREDENTIALS_CLIENT_ID}&response_type=code&redirect_uri=${encodeURI(
    outlookConfig.redirectUri,
  )}&response_mode=query&scope=calendars.read%20offline_access%20user.read&prompt=consent&state=${slug}`;
};
